import { ReactComponent as Parloa } from "../../../static/partner-logos/parloa.svg";
import { ReactComponent as Prima } from "../../../static/partner-logos/prima.svg";
import { ReactComponent as Workpath } from "../../../static/partner-logos/workpath.svg";
import { ReactComponent as Forto } from "../../../static/partner-logos/forto.svg";
import React from "react";

const ORBEM_LOGO = "/partner-logos/orbem.png";

function OrbemLogo(props: { className?: string }) {
    const base = "h-5 w-auto";
    const cls = props.className ? `${base} ${props.className}` : base;
    return (
        <>
            <img src={ORBEM_LOGO} alt="Orbem" className={`hidden ${cls} dark:block`} />
            <img src={ORBEM_LOGO} alt="Orbem" className={`block ${cls} invert dark:hidden`} />
        </>
    );
}

export default function CustomerLogos(props: React.HTMLProps<HTMLDivElement>) {
    return (
        <div {...props}>
            <p className={"mb-2 text-center text-xs font-semibold text-muted-foreground"}>Trusted by Tech Leaders</p>
            <div className={"grid grid-cols-5 items-stretch justify-center gap-x-3"}>
                <div className={"flex flex-col items-center justify-center"}>
                    <Parloa className={"[&_*]:fill-foreground"} />
                </div>
                <div className={"flex flex-col items-center justify-center"}>
                    <Prima className={"[&_*]:fill-foreground"} />
                </div>
                <div className={"flex flex-col items-center justify-center"}>
                    <Workpath className={"[&_*]:fill-foreground"} />
                </div>
                <div className={"flex flex-col items-center justify-center"}>
                    <Forto className={"[&>_*]:fill-foreground"} />
                </div>
                <div className={"flex flex-col items-center justify-center"}>
                    <OrbemLogo />
                </div>
            </div>
        </div>
    );
}
